import Instance from "../../../../Axios";

// New Actions for the app

const GetIdadeMedia =
  (parceirosId, dataInicio, dataFim) => async (dispatch) => {
    await Instance()
      .get(`/energias/dashboard/idadeMedia`, {
        params: { parceirosId, dataInicio, dataFim },
      })
      .then(({ data }) => {
        //   console.log(data);
        dispatch({
          type: "GET_IDADE_MEDIA",
          payload: data.yData[0].idadeMedia,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default GetIdadeMedia;
